import { render, staticRenderFns } from "./VisuwellUser.vue?vue&type=template&id=2ceb2850&scoped=true&"
import script from "./VisuwellUser.vue?vue&type=script&lang=js&"
export * from "./VisuwellUser.vue?vue&type=script&lang=js&"
import style0 from "./VisuwellUser.vue?vue&type=style&index=0&id=2ceb2850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb2850",
  null
  
)

export default component.exports